import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Box, Collapse, useMediaQuery } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close'; // Add close icon for the drawer
import './Header.scss';
import UnifiedButton from './Button';
import fmlogo from '../../assets/Images/fmdo-logo-teal.png';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function Header() {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const isMobile = useMediaQuery('(max-width: 1000px)');
    const [servicesOpen, setServicesOpen] = useState(false);
    const [supportOpen, setSupportOpen] = useState(false);
    const navigate = useNavigate();

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    const toggleServicesMenu = () => {
        setServicesOpen(!servicesOpen);
    };

    const toggleSupportMenu = () => {
        setSupportOpen(!supportOpen);
    };

    const handleTryOnceClick = () => {
        navigate('/pricing');
        window.scrollTo(0, 0); // Scroll to top when navigating
    };

    const handlesignin = () => {
        window.location.href = "https://app.fmdigitalofficial.com/sign-in";
        window.scrollTo(0, 0); // Scroll to top when navigating
    };


    const handleLinkClick = (path) => {
        navigate(path);
        window.scrollTo(0, 0); // Scroll to top on link click
        setDrawerOpen(false); // Close the drawer after navigating
    };

    const drawerList = () => (
        <div
            className="drawer-list"
            role="presentation"
            onKeyDown={toggleDrawer(false)}

        >
            <Box className="drawer-header">
                <Box className="drawer-logo-container">
                    <Link to="/" onClick={() => handleLinkClick('/')}>
                        <img src={fmlogo} alt="FM Logo" />
                    </Link>
                </Box>
                <IconButton onClick={toggleDrawer(false)} className="close-icon" aria-label="Close menu">
                    <CloseIcon />
                </IconButton>
            </Box>
            <List className="drawer-nav">
                <ListItem button onClick={() => handleLinkClick('/sell-your-music')} className="drawer-item">
                    <ListItemText primary="Sell Your Music" />
                </ListItem>
                <ListItem button onClick={() => handleLinkClick('/pricing')} className="drawer-item">
                    <ListItemText primary="Pricing" />
                </ListItem>
                <ListItem button onClick={toggleServicesMenu} className="drawer-item">
                    <ListItemText primary="Services" />
                    {servicesOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItem>
                <Collapse in={servicesOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button onClick={() => handleLinkClick('/services/featured-playlists')} className="drawer-subitem">
                            <ListItemText primary="Featured Playlists" />
                        </ListItem>
                        <ListItem button onClick={() => handleLinkClick('/services/music-marketing')} className="drawer-subitem">
                            <ListItemText primary="Music Marketing" />
                        </ListItem>
                    </List>
                </Collapse>
                <ListItem button onClick={toggleSupportMenu} className="drawer-item">
                    <ListItemText primary="Support" />
                    {supportOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItem>
                <Collapse in={supportOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button onClick={() => handleLinkClick('/support/legal-documents')} className="drawer-subitem">
                            <ListItemText primary="Legal Documents" />
                        </ListItem>
                        <ListItem button onClick={() => handleLinkClick('/support/legal-forms')} className="drawer-subitem">
                            <ListItemText primary="Legal Forms" />
                        </ListItem>
                    </List>
                </Collapse>
                <ListItem button onClick={() => handleLinkClick('/about')} className="drawer-item">
                    <ListItemText primary="About" />
                </ListItem>
                <ListItem className="drawer-item drawer-item--action">
                    <UnifiedButton onClick={handlesignin} textContent={"Log in"} />
                </ListItem>
                <ListItem className="drawer-item drawer-item--action">
                    <UnifiedButton onClick={handleTryOnceClick} textContent={"Try Once"} />
                </ListItem>
            </List>
        </div>
    );

    return (
        <AppBar position="static" className="header">
            <Toolbar className="toolbar">
                {/* <Box className="logo-container">
                    <Link to="/" onClick={() => window.scrollTo(0, 0)}>
                        <img src={fmlogo} alt="FM Logo" />
                    </Link>
                </Box> */}
                {isMobile ? (
                    <Box className="header-mobile-bar">
                        {/* Logo stays visible on mobile so the bar never looks empty */}
                        <Box className="logo-container">
                            <Link to="/" onClick={() => window.scrollTo(0, 0)}>
                                <img src={fmlogo} alt="FM Logo" />
                            </Link>
                        </Box>
                        <IconButton
                            className="menu-toggle"
                            aria-label="Open navigation menu"
                            onClick={toggleDrawer(true)}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Drawer
                            anchor="right"
                            open={drawerOpen}
                            onClose={toggleDrawer(false)}
                            PaperProps={{ sx: { maxWidth: '100vw' } }}
                        >
                            {drawerList()}
                        </Drawer>
                    </Box>
                ) : (
                    <>
                        <Box className="logo-container">
                            <Link to="/" onClick={() => window.scrollTo(0, 0)}>
                                <img src={fmlogo} alt="FM Logo" />
                            </Link>
                        </Box>
                        <div className="nav-links">
                            <Link to="/sell-your-music" className="nav-link" onClick={() => window.scrollTo(0, 0)}>Sell Your Music</Link>
                            <Link to="/pricing" className="nav-link" onClick={() => window.scrollTo(0, 0)}>Pricing</Link>
                            <div className="nav-link">
                                Services
                                <div className="dropdown-menu">
                                    <Link to="/services/featured-playlists" className="dropdown-item" onClick={() => window.scrollTo(0, 0)}>Featured Playlists</Link>
                                    <Link to="/services/music-marketing" className="dropdown-item" onClick={() => window.scrollTo(0, 0)}>Music Marketing</Link>
                                </div>
                            </div>
                            <div className="nav-link">
                                Support
                                <div className="dropdown-menu">
                                    <Link to="/support/legal-documents" className="dropdown-item" onClick={() => window.scrollTo(0, 0)}>Legal Documents</Link>
                                    <Link to="/support/legal-forms" className="dropdown-item" onClick={() => window.scrollTo(0, 0)}>Legal Forms</Link>
                                </div>
                            </div>
                            <Link to="/about" className="nav-link" onClick={() => window.scrollTo(0, 0)}>About</Link>
                        </div>
                        <div className="auth-links">
                            <UnifiedButton onClick={handlesignin} className="header-auth-button" textContent={"Log in"} />
                            <UnifiedButton className="header-auth-button" onClick={handleTryOnceClick} textContent={"Try Once"} />
                        </div>
                    </>
                )}
            </Toolbar>
        </AppBar>
    );
}

export default Header;
